import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { EntityTypeConfigKeys } from '@utils/entityViewConfig';
import { APP_PATHS, PAGE_PATHS, Permission } from '../../../../../types';

const path = PAGE_PATHS.USERS;
export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/identities/users/')({
  staticData: {
    path,
    key: EntityTypeConfigKeys.User,
  },
  validateSearch: zodValidator(withDefaults(schema.USERS, defaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path, app: APP_PATHS.IDENTITIES, permission: Permission.READ });
    context.validatePermissions({ isAllowed, preload });
  },
});
